import { render, staticRenderFns } from "./xwtrade.vue?vue&type=template&id=0823aff8&scoped=true&"
import script from "./xwtrade.vue?vue&type=script&lang=js&"
export * from "./xwtrade.vue?vue&type=script&lang=js&"
import style0 from "./xwtrade.vue?vue&type=style&index=0&id=0823aff8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0823aff8",
  null
  
)

export default component.exports